<template>

<!--    <component :is="currentView" />-->
    <router-view></router-view>
</template>

<script>

</script>
<style setup>
body{
    background-color: #f2f2f2;
}
</style>